import { LocaleId } from '@portfolio/configs'
import { groq } from 'next-sanity'
import { coalesceLocaleField } from '../helpers/coalesceLocaleField'

export const createSectionExternalArtifactProjection = (localeId: LocaleId) => {
  return groq`{
    _key,
    _type,
    "artifactUrl": select(
      defined(artifactFile.asset->_id) => "/api/artifact/" + artifactFile.asset->_id
    ),
    "artifactUrlMobile": select(
      defined(artifactFileMobile.asset->_id) => "/api/artifact/" + artifactFileMobile.asset->_id
    ),
    aspectRatioWidth,
    aspectRatioHeight,
    aspectRatioMobileWidth,
    aspectRatioMobileHeight,
    ${coalesceLocaleField('altText', localeId)},
    ${coalesceLocaleField('caption', localeId)},
  }`
}
